<template>
  <div class="wholeContext">
  <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
    <tracking-progress :transDataSet="transDate"></tracking-progress>
    <div class="join container">
      <div class="joinTitle">
        <h3>동의하기</h3>
        <p class="warn">필수 동의 사항입니다.</p>
      </div>
      <div class="joinContext">
<!--        <div class="wholeCheck article" @click="authorizeWholeCheck">-->
<!--          <p>전체동의</p><span class="imgWrap"><img :src="authorizeChecked.wholeCheck ? buttonCheckUrl.checkOn : buttonCheckUrl.checkUn"></span>-->
<!--        </div>-->
        <div class="article term" v-if="this.getTemporaryTerms">
          <p>서비스 이용약관</p>
          <span class="imgWrap">
            <img :src="require(`@/assets/images/${agreeBtn.checkOn}`)">
          </span>
        </div>
        <div class="article term" v-else @click="serviceAgree">
          <p>서비스 이용약관</p>
          <span class="imgWrap rotate">
            <img :src="require(`@/assets/images/${agreeBtn.checkUn}`)">
          </span>
        </div>
        <div class="article term" v-if="this.getTemporaryPrivacy">
          <p>개인정보 수집이용동의</p>
          <span class="imgWrap">
            <img :src="require(`@/assets/images/${agreeBtn.checkOn}`)">
          </span>
        </div>
        <div class="article term" v-else @click="individualAgree">
          <p>개인정보 수집이용동의</p>
          <span class="imgWrap rotate">
            <img :src="require(`@/assets/images/${agreeBtn.checkUn}`)">
          </span>
        </div>
        <div class="preData">
          <div class="article require user">
           <input type="text" v-model="temporaryForm.userName.value" maxlength="21" @keyup="blurUserName()" @blur="blurUserName()" placeholder="이름"/>
          </div>
          <div class="article require gender" @click="genderCollapse" >
            <p class="represent">{{labelName}}</p>
            <div class="uberButton pointer" :class="{visible : collapseFlag }">
              <span class="imgWrap">
                <img :src="collapseFlag ? buttonCheckUrl.collapseUn : buttonCheckUrl.collapseOn">
              </span>
              <div class="uberContext">
                <label for="man" class="pointer">남성<input type="radio" id="man" name="gender"  v-model="temporaryForm.gender.value" value="M" @click="changeGender"></label>
                <label for="women" class="noneBorder pointer">여성<input type="radio" id="women" name="gender" value="F" v-model="temporaryForm.gender.value" @click="changeGender"></label>
              </div>
            </div>
          </div>
          <div class="article require birthDate">
            <input type="text" class=""  v-model="temporaryForm.birthDate.value" maxlength="10" @keyup="blurBirthDate()" @input="formatBirthNumber(temporaryForm.birthDate.value)" placeholder="YYYY-MM-DD"/>
          </div>
        </div>
        <span class="warn" v-if="!this.getTemporaryPrivacy || !this.getTemporaryTerms" v-text="authorizeChecked.errMsg"></span>
        <span class="warn" v-if="temporaryForm.userName.hasError" v-text="temporaryForm.userName.errorTxt"></span>
        <span class="warn" v-if="temporaryForm.gender.hasError" v-text="temporaryForm.gender.errorTxt"></span>
        <span class="warn" v-if="temporaryForm.birthDate.hasError" v-text="temporaryForm.birthDate.errorTxt"></span>
        </div>
      </div>
    </div>
    <div class="btnWrap" :class="{visible : authorizeChecked.wholeCheck && temporaryForm.userName.flag && temporaryForm.gender.value!=='' && temporaryForm.birthDate.flag}">
      <button type="button" class="callTerms" @click="nextFormDataTemporary">다음</button>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet" @causeAction="serviceAgree()"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import { mapMutations, mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        bigModal: false,
        closeType: 'close'
      },
      collapseTouch: false,
      transDate: {
        headerName: '회원가입',
        progressNum: '25%',
        chapterNum: 1,
        prevUrl: '/ChoiceType'
      },
      collapseFlag: false,
      labelName: '성별',
      authorizeChecked: {
        wholeCheck: false,
        serviceCheck: false,
        individualCheck: false,
        errMsg: '모든 항목에 동의해주세요.',
        checkConfirm: false,
        isActive: true
      },
      buttonCheckUrl: {
        checkOn: 'images/ck_on.png',
        checkUn: 'images/ck_un.png',
        collapseOn: 'images/dropdown.png',
        collapseUn: 'images/dropup.png'
      },
      temporaryForm: {
        userName: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        gender: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        birthDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      agreeBtn: {
        checkOn: 'ck_on.svg',
        checkUn: 'dropdown.svg'
      },
      setCount: false,
      agreeFlag: false
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'getTemporaryPrivacy',
      'getTemporaryTerms'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_TEMPORARY_TERMS',
      'SET_TEMPORARY_PRIVACY'
    ]),
    // authorizeWholeCheck () {
    //   if (!this.authorizeChecked.wholeCheck) {
    //     this.authorizeChecked.serviceCheck = true
    //     this.authorizeChecked.individualCheck = true
    //     this.authorizeChecked.checkConfirm = true
    //     this.authorizeChecked.isActive = true
    //   } else {
    //     this.authorizeChecked.serviceCheck = false
    //     this.authorizeChecked.individualCheck = false
    //     this.authorizeChecked.checkConfirm = false
    //     this.authorizeChecked.isActive = false
    //   }
    //   this.authorizeChecked.wholeCheck = !this.authorizeChecked.wholeCheck
    // },
    serviceAgree () {
      this.$router.push('/temporaryTerms')
    },
    individualAgree () {
      this.$router.push('/temporaryPrivacy')
    },
    // authorizeServiceCheck () {
    //   if (this.authorizeChecked.individualCheck && !this.authorizeChecked.serviceCheck) {
    //     this.authorizeChecked.wholeCheck = true
    //     this.authorizeChecked.checkConfirm = true
    //     this.authorizeChecked.isActive = true
    //   } else {
    //     this.authorizeChecked.wholeCheck = false
    //     this.authorizeChecked.checkConfirm = false
    //     this.authorizeChecked.isActive = false
    //   }
    //   this.authorizeChecked.serviceCheck = !this.authorizeChecked.serviceCheck
    // },
    // authorizeIndividualCheck () {
    //   if (this.authorizeChecked.serviceCheck && !this.authorizeChecked.individualCheck) {
    //     this.authorizeChecked.wholeCheck = true
    //     this.authorizeChecked.checkConfirm = true
    //     this.authorizeChecked.isActive = true
    //   } else {
    //     this.authorizeChecked.wholeCheck = false
    //     this.authorizeChecked.checkConfirm = false
    //     this.authorizeChecked.isActive = false
    //   }
    //   this.authorizeChecked.individualCheck = !this.authorizeChecked.individualCheck
    // },
    transData () {
      const temporaryData = {
        userName: this.temporaryForm.userName.value.replace(/\s/gi, ''),
        gender: this.temporaryForm.gender.value.replace(/\s/gi, ''),
        birthDate: this.temporaryForm.birthDate.value.replace(/\s/gi, ''),
        userNameFlag: this.temporaryForm.userName.flag,
        genderFlag: this.temporaryForm.gender.flag,
        birthDateFlag: this.temporaryForm.birthDate.flag
      }
      console.log('transData', temporaryData)
      this.$store.commit('SET_TEMPORARY_DATA', temporaryData)
      this.$router.push('/FormDataTemporary')
      this.SET_TEMPORARY_TERMS(false)
      this.SET_TEMPORARY_PRIVACY(false)
    },
    nextFormDataTemporary () {
      if (this.checkAll()) {
        console.log('전송성공')
        this.transData()
      } else {
        console.log('전송실패')
        if (!this.authorizeChecked.wholeCheck) {
          this.popupSet.content = '모든 항목에 동의해주세요.'
          this.SET_POPUP(true)
          this.authorizeChecked.isActive = false
          this.authorizeChecked.checkConfirm = false
        } else if (!this.temporaryForm.userName.flag) {
          this.popupSet.content = '이름을 확인해주세요.'
          this.SET_POPUP(true)
        } else if (!this.temporaryForm.gender.flag) {
          this.popupSet.content = '성별을 확인해주세요.'
          this.SET_POPUP(true)
        } else if (!this.temporaryForm.birthDate.flag) {
          this.popupSet.content = '생년월일을 확인해주세요.'
          this.SET_POPUP(true)
        } else {
        }
      }
    },
    blurUserName () {
      this.temporaryForm.userName.flag = false
      this.checkUserName()
    },
    checkUserName () {
      if (this.temporaryForm.userName.flag) return true
      const userName = this.temporaryForm.userName.value.replace(/\s/gi, '')
      if (userName === '') {
        this.temporaryForm.userName.hasError = true
        this.temporaryForm.userName.errorTxt = '이름을 입력해주세요.'
        this.temporaryForm.userName.flag = false
        return false
      }
      // const isUserName = /^[가-힣]{2,5}$/
      // if (!isUserName.test(userName)) {
      //   this.temporaryForm.userName.hasError = true
      //   this.temporaryForm.userName.errorTxt = '2~5자리의 한글만 입력가능합니다.'
      //   this.temporaryForm.userName.flag = false
      //   return false
      // }
      this.temporaryForm.userName.flag = true
      this.temporaryForm.userName.hasError = false
      this.temporaryForm.userName.errorTxt = ''
      return true
    },
    blurBirthDate () {
      this.temporaryForm.birthDate.flag = false
      this.checkblurBirthDate()
    },
    checkblurBirthDate () {
      if (this.temporaryForm.birthDate.flag) return true
      const birthDate = this.temporaryForm.birthDate.value.replace(/\s/gi, '')
      if (birthDate === '') {
        this.temporaryForm.birthDate.hasError = true
        this.temporaryForm.birthDate.errorTxt = '생년월일을 입력해주세요.'
        return false
      }
      const isBirthDate = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
      if (!isBirthDate.test(birthDate)) {
        this.temporaryForm.birthDate.hasError = true
        this.temporaryForm.birthDate.errorTxt = '생년월일을 바르게 입력해주세요.'
        return false
      }
      this.temporaryForm.birthDate.flag = true
      this.temporaryForm.birthDate.hasError = false
      this.temporaryForm.birthDate.errorTxt = ''
      return true
    },
    genderCollapse () {
      this.collapseFlag = !this.collapseFlag
      this.collapseTouch = true
      if (this.collapseTouch && !this.temporaryForm.gender.flag) {
        this.temporaryForm.gender.hasError = true
        this.temporaryForm.gender.errorTxt = '성별을 선택해주세요.'
      }
    },
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 5) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 4)
        phone += '-'
        phone += number.substr(4)
      } else if (number.length < 9) {
        phone += number.substr(0, 4)
        phone += '-'
        phone += number.substr(4, 2)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 4)
        phone += '-'
        phone += number.substr(4, 2)
        phone += '-'
        phone += number.substr(6)
      }
      return phone
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.temporaryForm.birthDate.value = this.formatBirth(obj)
    },
    changeGender () {
      this.temporaryForm.gender.flag = false
      const sex = document.getElementsByName('gender')
      let radioValue
      for (let i = 0; i < sex.length; i++) {
        if (sex[i].checked) {
          radioValue = sex[i].value
        }
      }
      if (radioValue === 'M') {
        this.labelName = '남성'
        this.temporaryForm.gender.flag = true
        this.temporaryForm.gender.hasError = false
        this.temporaryForm.gender.errorTxt = ''
      } else if (radioValue === 'F') {
        this.labelName = '여성'
        this.temporaryForm.gender.flag = true
        this.temporaryForm.gender.hasError = false
        this.temporaryForm.gender.errorTxt = ''
      } else {
        this.temporaryForm.gender.flag = false
        this.temporaryForm.gender.hasError = true
        this.temporaryForm.gender.errorTxt = '성별을 선택해주세요.'
      }
      this.collapseFlag = !this.collapseFlag
    },
    checkAll () {
      return !!(this.temporaryForm.gender.flag && this.temporaryForm.birthDate.flag &&
        this.temporaryForm.userName.flag && this.authorizeChecked.wholeCheck)
    },
    autoDateFormat (e, oThis) {
      const numArr = [
        97, 98, 99, 100, 101, 102, 103, 104, 105, 96,
        48, 49, 50, 51, 52, 53, 54, 55, 56, 57
      ]
      const keyCode = (e.which) ? e.which : e.keyCode
      if (numArr.indexOf(Number(keyCode)) !== -1) {
        const len = oThis.value.length
        if (len === 4) oThis.value += '-'
        if (len === 7) oThis.value += '-'
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/ChoiceType')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    if (this.getTemporaryPrivacy && this.getTemporaryTerms) {
      this.authorizeChecked.wholeCheck = true
      this.agreeFlag = true
    } else {
      this.authorizeChecked.wholeCheck = false
      this.agreeFlag = false
    }
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
  .join.container .joinContext .preData .article.require  {
    input {
      width:100%;
    }
  }
</style>
